/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { getEntities as getMedicines } from 'app/entities/medicine/medicine.reducer';
import { getEntities as getPharmacySuppliers } from 'app/entities/pharmacy-suppliers/pharmacy-suppliers.reducer';
import { getEntities as getPharmacyStockBills } from 'app/entities/pharmacy-stock-bill/pharmacy-stock-bill.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-stock.reducer';

export const PharmacyStockUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const medicines = useAppSelector(state => state.medicine.entities);
  const pharmacySuppliers = useAppSelector(state => state.pharmacySuppliers.entities);
  const pharmacyStockBills = useAppSelector(state => state.pharmacyStockBill.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const pharmacyStockEntity = useAppSelector(state => state.pharmacyStock.entity);
  const loading = useAppSelector(state => state.pharmacyStock.loading);
  const updating = useAppSelector(state => state.pharmacyStock.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyStock.updateSuccess);
  const pharmacyAddedByTypeValues = Object.keys(PharmacyAddedByType);

  const handleClose = () => {
    navigate(`/pharmacy-stock${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacies({}));
    dispatch(getMedicines({}));
    dispatch(getPharmacySuppliers({}));
    dispatch(getPharmacyStockBills({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.stockQty !== undefined && typeof values.stockQty !== 'number') {
      values.stockQty = Number(values.stockQty);
    }
    if (values.manufacDate !== undefined && typeof values.manufacDate !== 'number') {
      values.manufacDate = Number(values.manufacDate);
    }
    if (values.expDate !== undefined && typeof values.expDate !== 'number') {
      values.expDate = Number(values.expDate);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.mrp !== undefined && typeof values.mrp !== 'number') {
      values.mrp = Number(values.mrp);
    }
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }
    if (values.remainingQuantity !== undefined && typeof values.remainingQuantity !== 'number') {
      values.remainingQuantity = Number(values.remainingQuantity);
    }
    if (values.packs !== undefined && typeof values.packs !== 'number') {
      values.packs = Number(values.packs);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.margin !== undefined && typeof values.margin !== 'number') {
      values.margin = Number(values.margin);
    }
    if (values.cessAmount !== undefined && typeof values.cessAmount !== 'number') {
      values.cessAmount = Number(values.cessAmount);
    }
    if (values.importDuty !== undefined && typeof values.importDuty !== 'number') {
      values.importDuty = Number(values.importDuty);
    }
    if (values.freeQty !== undefined && typeof values.freeQty !== 'number') {
      values.freeQty = Number(values.freeQty);
    }

    const entity = {
      ...pharmacyStockEntity,
      ...values,
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
      drug: medicines.find(it => it.id.toString() === values.drug?.toString()),
      supplier: pharmacySuppliers.find(it => it.id.toString() === values.supplier?.toString()),
      stockBill: pharmacyStockBills.find(it => it.id.toString() === values.stockBill?.toString()),
      uqcType: clinicalDictionaries.find(it => it.id.toString() === values.uqcType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          addedByType: 'PHARMACY',
          modifiedByType: 'PHARMACY',
          ...pharmacyStockEntity,
          pharmacy: pharmacyStockEntity?.pharmacy?.id,
          drug: pharmacyStockEntity?.drug?.id,
          supplier: pharmacyStockEntity?.supplier?.id,
          stockBill: pharmacyStockEntity?.stockBill?.id,
          uqcType: pharmacyStockEntity?.uqcType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyStock.home.createOrEditLabel" data-cy="PharmacyStockCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyStock.home.createOrEditLabel">Create or edit a PharmacyStock</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-stock-id"
                  label={translate('tinyMedicRestApp.pharmacyStock.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.brandId')}
                id="pharmacy-stock-brandId"
                name="brandId"
                data-cy="brandId"
                type="text"
                validate={{
                  maxLength: { value: 150, message: translate('entity.validation.maxlength', { max: 150 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.stockQty')}
                id="pharmacy-stock-stockQty"
                name="stockQty"
                data-cy="stockQty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.manufacDate')}
                id="pharmacy-stock-manufacDate"
                name="manufacDate"
                data-cy="manufacDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.expDate')}
                id="pharmacy-stock-expDate"
                name="expDate"
                data-cy="expDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.timestampentry')}
                id="pharmacy-stock-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.microSec')}
                id="pharmacy-stock-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.lastupdated')}
                id="pharmacy-stock-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.active')}
                id="pharmacy-stock-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.cursor')}
                id="pharmacy-stock-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.batchNumber')}
                id="pharmacy-stock-batchNumber"
                name="batchNumber"
                data-cy="batchNumber"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <UncontrolledTooltip target="batchNumberLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyStock.help.batchNumber" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.taxCode')}
                id="pharmacy-stock-taxCode"
                name="taxCode"
                data-cy="taxCode"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.mrp')}
                id="pharmacy-stock-mrp"
                name="mrp"
                data-cy="mrp"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.price')}
                id="pharmacy-stock-price"
                name="price"
                data-cy="price"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.remainingQuantity')}
                id="pharmacy-stock-remainingQuantity"
                name="remainingQuantity"
                data-cy="remainingQuantity"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.packs')}
                id="pharmacy-stock-packs"
                name="packs"
                data-cy="packs"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.HSNCode')}
                id="pharmacy-stock-HSNCode"
                name="HSNCode"
                data-cy="HSNCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.rack')}
                id="pharmacy-stock-rack"
                name="rack"
                data-cy="rack"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.discount')}
                id="pharmacy-stock-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.available')}
                id="pharmacy-stock-available"
                name="available"
                data-cy="available"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.internal')}
                id="pharmacy-stock-internal"
                name="internal"
                data-cy="internal"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.shipmentItemId')}
                id="pharmacy-stock-shipmentItemId"
                name="shipmentItemId"
                data-cy="shipmentItemId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.addedById')}
                id="pharmacy-stock-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.modifiedById')}
                id="pharmacy-stock-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.addedByType')}
                id="pharmacy-stock-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.modifiedByType')}
                id="pharmacy-stock-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.margin')}
                id="pharmacy-stock-margin"
                name="margin"
                data-cy="margin"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.cessAmount')}
                id="pharmacy-stock-cessAmount"
                name="cessAmount"
                data-cy="cessAmount"
                type="text"
              />
              <UncontrolledTooltip target="cessAmountLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyStock.help.cessAmount" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.exempted')}
                id="pharmacy-stock-exempted"
                name="exempted"
                data-cy="exempted"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="exemptedLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyStock.help.exempted" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.importDuty')}
                id="pharmacy-stock-importDuty"
                name="importDuty"
                data-cy="importDuty"
                type="text"
              />
              <UncontrolledTooltip target="importDutyLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyStock.help.importDuty" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStock.freeQty')}
                id="pharmacy-stock-freeQty"
                name="freeQty"
                data-cy="freeQty"
                type="text"
              />
              <UncontrolledTooltip target="freeQtyLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyStock.help.freeQty" />
              </UncontrolledTooltip>
              <ValidatedField
                id="pharmacy-stock-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacyStock.pharmacy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-stock-drug"
                name="drug"
                data-cy="drug"
                label={translate('tinyMedicRestApp.pharmacyStock.drug')}
                type="select"
                required
              >
                <option value="" key="0" />
                {medicines
                  ? medicines.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-stock-supplier"
                name="supplier"
                data-cy="supplier"
                label={translate('tinyMedicRestApp.pharmacyStock.supplier')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacySuppliers
                  ? pharmacySuppliers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-stock-stockBill"
                name="stockBill"
                data-cy="stockBill"
                label={translate('tinyMedicRestApp.pharmacyStock.stockBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyStockBills
                  ? pharmacyStockBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-stock-uqcType"
                name="uqcType"
                data-cy="uqcType"
                label={translate('tinyMedicRestApp.pharmacyStock.uqcType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-stock" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyStockUpdate;
